import React, { useState } from "react";
import KuralTable from "./KuralTable";
import api from "../utils/api";
import Swal from "sweetalert2"; // Import SweetAlert

const Kurals = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Changed from showForm to isModalOpen
  const [formData, setFormData] = useState({
    id: "",
    kural_no: "",
    athikaram: "",
    athikaram_no: "",
    kural_line1: "",
    kural_line2: "",
    kural: "",
    meaning_ta_mu_va: "",
    meaning_ta_salaman: "",
    meaning_ta_mk: "",
    meaning_ta_others1: "",
    meaning_ta_others2: "",
    meaning_ta_others3: "",
    active: true,
  });
  const [isEditing, setIsEditing] = useState(false);

  const resetForm = () => {
    setFormData({
      id: "",
      kural_no: "",
      athikaram: "",
      athikaram_no: "",
      kural_line1: "",
      kural_line2: "",
      kural: "",
      meaning_ta_mu_va: "",
      meaning_ta_salaman: "",
      meaning_ta_mk: "",
      meaning_ta_others1: "",
      meaning_ta_others2: "",
      meaning_ta_others3: "",
      active: true,
    });
    setIsEditing(false);
  };

  const toggleModal = () => {
    if (!isModalOpen) {
      resetForm();
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleEdit = (kural) => {
    setFormData({
      id: kural.id,
      kural_no: kural.kural_no,
      athikaram: kural.athikaram,
      athikaram_no: kural.athikaram_no,
      kural_line1: kural.kural_line1,
      kural_line2: kural.kural_line2,
      kural: kural.kural,
      meaning_ta_mu_va: kural.meaning_ta_mu_va,
      meaning_ta_salaman: kural.meaning_ta_salaman,
      meaning_ta_mk: kural.meaning_ta_mk,
      meaning_ta_others1: kural.meaning_ta_others1,
      meaning_ta_others2: kural.meaning_ta_others2,
      meaning_ta_others3: kural.meaning_ta_others3,
      active:
        kural.active === "1" || kural.active === 1 || kural.active === true,
    });
    setIsEditing(true);
    setIsModalOpen(true); // Changed from setShowForm to setIsModalOpen
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (isEditing) {
        // Update existing kural
        response = await api.put(`/api/kural/index.php`, formData);
        if (response.status === 200) {
          Swal.fire({
            title: "Kural Updated!",
            text: response.data.message || "Kural has been updated successfully",
            icon: "success",
          });
        }
      } else {
        // Create new kural
        response = await api.post(`/api/kural/index.php`, formData);
        if (response.status === 201) {
          Swal.fire({
            title: "Kural Created!",
            text: response.data.message || "Kural has been created successfully",
            icon: "success",
          });
        }
      }
      resetForm();
      setIsModalOpen(false); // Changed from setShowForm to setIsModalOpen
      // You might want to refresh the table here
    } catch (error) {
      console.error("Error saving kural:", error);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Failed to save Kural",
        icon: "error",
      });
    }
  };

  const handleDelete = async (kuralId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Kural!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await api.delete(`/api/kural/index.php?id=${kuralId}`);
          if (response.status === 200) {
            Swal.fire({
              title: "Deleted!",
              text: response.data.message || "Kural has been deleted.",
              icon: "success",
            });
            // You might want to refresh the table here
          }
        } catch (error) {
          console.error("Error deleting kural:", error);
          Swal.fire({
            title: "Error",
            text: error.response?.data?.message || "Failed to delete Kural",
            icon: "error",
          });
        }
      }
    });
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Kurals Management</h1>
        <button
          onClick={toggleModal}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Add New Kural
        </button>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50 overflow-y-auto">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-3 sm:p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg sm:text-xl font-semibold">
                  {isEditing ? "Edit Kural" : "Add New Kural"}
                </h2>
                <button
                  onClick={toggleModal}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <svg
                    className="h-5 w-5 sm:h-6 sm:w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                  <div className="mb-3 sm:mb-4">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Kural No
                    </label>
                    <input
                      type="number"
                      name="kural_no"
                      value={formData.kural_no}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      required
                    />
                  </div>
                  {/* Repeat the same pattern for all other form fields */}
                  <div className="mb-3 sm:mb-4">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Athikaram
                    </label>
                    <input
                      type="text"
                      name="athikaram"
                      value={formData.athikaram}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      required
                    />
                  </div>
                  <div className="mb-3 sm:mb-4">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Athikaram No
                    </label>
                    <input
                      type="number"
                      name="athikaram_no"
                      value={formData.athikaram_no}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      required
                    />
                  </div>
                  <div className="mb-3 sm:mb-4">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Kural Line 1
                    </label>
                    <input
                      type="text"
                      name="kural_line1"
                      value={formData.kural_line1}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      required
                    />
                  </div>
                  <div className="mb-3 sm:mb-4">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Kural Line 2
                    </label>
                    <input
                      type="text"
                      name="kural_line2"
                      value={formData.kural_line2}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      required
                    />
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Full Kural
                    </label>
                    <textarea
                      name="kural"
                      value={formData.kural}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Meaning (Mu. Varadarajan)
                    </label>
                    <textarea
                      name="meaning_ta_mu_va"
                      value={formData.meaning_ta_mu_va}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Meaning (Salamon)
                    </label>
                    <textarea
                      name="meaning_ta_salaman"
                      value={formData.meaning_ta_salaman}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Meaning (MK)
                    </label>
                    <textarea
                      name="meaning_ta_mk"
                      value={formData.meaning_ta_mk}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Additional Meaning 1
                    </label>
                    <textarea
                      name="meaning_ta_others1"
                      value={formData.meaning_ta_others1}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Additional Meaning 2
                    </label>
                    <textarea
                      name="meaning_ta_others2"
                      value={formData.meaning_ta_others2}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 sm:col-span-2">
                    <label className="block text-gray-700 text-xs sm:text-sm font-bold mb-1 sm:mb-2">
                      Additional Meaning 3
                    </label>
                    <textarea
                      name="meaning_ta_others3"
                      value={formData.meaning_ta_others3}
                      onChange={handleInputChange}
                      className="shadow appearance-none border rounded w-full py-1 sm:py-2 px-2 sm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm"
                      rows="2"
                    ></textarea>
                  </div>
                  <div className="mb-3 sm:mb-4 flex items-center">
                    <label className="flex items-center cursor-pointer">
                      <div className="relative">
                        <input
                          type="checkbox"
                          name="active"
                          checked={formData.active}
                          onChange={handleInputChange}
                          className="sr-only"
                        />
                        <div
                          className={`block w-10 sm:w-14 h-6 sm:h-8 rounded-full ${formData.active ? "bg-green-500" : "bg-red-500"}`}
                        ></div>
                        <div
                          className={`dot absolute left-1 top-1 bg-white w-4 sm:w-6 h-4 sm:h-6 rounded-full transition ${formData.active ? "transform translate-x-4 sm:translate-x-6" : ""}`}
                        ></div>
                      </div>
                      <div className="ml-3 text-gray-700 text-xs sm:text-sm font-medium">Active</div>
                    </label>
                  </div>
                </div>
                <div className="flex items-center justify-end mt-4 sm:mt-6 space-x-2 sm:space-x-3">
                  <button
                    type="button"
                    onClick={toggleModal}
                    className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 sm:py-2 px-3 sm:px-4 rounded focus:outline-none focus:shadow-outline text-xs sm:text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 sm:py-2 px-3 sm:px-4 rounded focus:outline-none focus:shadow-outline text-xs sm:text-sm"
                  >
                    {isEditing ? "Update Kural" : "Add Kural"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <KuralTable onEdit={handleEdit} onDelete={handleDelete} />
    </div>
  );
};

export default Kurals;
